import React from 'react'
import Tooltip from 'rc-tooltip'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'
import Hint from 'lib/tags/hint'
import BreakOnBr from 'lib/tags/break-on-br'

import Content from './content'

export default function Booking ({ noGuarantee }) {
  return (
    <div className='widget nospace white'>
      <h3 className='boxtitle line'>
        {I18n.t('courses.show.availability')}{' '}
        <Hint
          style={{ verticalAlign: 'text-top' }}
          text={<BreakOnBr text={I18n.t('courses.show_booking.title_hint')} />}
        />
      </h3>

      <div className='padding-no-top2'>
        <Content />
      </div>

      {!noGuarantee && (
        <h3 className='box-footer boxtitle'>
          <Tooltip
            placement='bottom'
            trigger={['hover']}
            overlay={
              <div className='hint-body'>
                <BreakOnBr text={I18n.t('courses.show_booking.guarantee_hint')} />
              </div>
            }
          >
            <div className='underline'>{I18n.t('courses.show_booking.guarantee')}</div>
          </Tooltip>
        </h3>
      )}
    </div>
  )
}

Booking.propTypes = {
  noGuarantee: PropTypes.bool
}
